var map = {
	"./fish-1.png": 992,
	"./fish-10.png": 993,
	"./fish-11.png": 994,
	"./fish-12.png": 995,
	"./fish-13.png": 996,
	"./fish-14.png": 997,
	"./fish-15.png": 998,
	"./fish-16.png": 999,
	"./fish-17.png": 1000,
	"./fish-18.png": 1001,
	"./fish-19.png": 1002,
	"./fish-2.png": 1003,
	"./fish-20.png": 1004,
	"./fish-21.png": 1005,
	"./fish-22.png": 1006,
	"./fish-23.png": 1007,
	"./fish-3.png": 1008,
	"./fish-4.png": 1009,
	"./fish-5.png": 1010,
	"./fish-6.png": 1011,
	"./fish-7.png": 1012,
	"./fish-8.png": 1013,
	"./fish-9.png": 1014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2006;